import { Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { format } from 'date-fns';
import { css } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const boundStyle = css`
  justify-content: space-between;
  padding-inline: 8px;
`;
const TransferDirection = props => {
  const {
    transferBounds,
    direction
  } = props;
  const {
    departureStation: from,
    arrivalStation: to
  } = transferBounds[direction];
  return /*#__PURE__*/_jsxs(Inline, {
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Text, {
      children: from
    }), /*#__PURE__*/_jsx(Text, {
      children: "-"
    }), /*#__PURE__*/_jsx(Text, {
      children: to
    })]
  });
};
const TransferBoundAvailability = _ref => {
  var _boundsData$direction;
  let {
    title,
    available,
    boundsData,
    direction
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 8,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: textVariants._14_BOLD,
      children: title
    }), /*#__PURE__*/_jsxs(Inline, {
      className: boundStyle,
      spacing: 4,
      children: [/*#__PURE__*/_jsxs(Stack, {
        spacing: 0,
        children: [/*#__PURE__*/_jsx(TransferDirection, {
          direction: direction,
          transferBounds: boundsData
        }), /*#__PURE__*/_jsx(Text, {
          children: format((_boundsData$direction = boundsData[direction].arrivalDateTime) !== null && _boundsData$direction !== void 0 ? _boundsData$direction : '', 'EEE, MMM do, yyyy')
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        spacing: 4,
        children: [/*#__PURE__*/_jsx(CheckCircle, {
          "aria-hidden": true,
          color: vars.colors.signal.positive.foreground,
          "data-testid": "add-icon",
          size: 20,
          weight: "regular"
        }), /*#__PURE__*/_jsx(Text, {
          children: available
        })]
      })]
    })]
  });
};
export default TransferBoundAvailability;
//# sourceMappingURL=TransferBoundAvailability.js.map